module.exports = __webpack_public_path__ + "static/media/status_warning.8d3d16c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/status_warning.svg
// module id = 518
// module chunks = 0